module.exports = "<app-aside-nav></app-aside-nav>\n<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\n\n\n\t<breadcrumb></breadcrumb>\n\n\t<div class=\"m-content\">\n\t\t\t<router-outlet></router-outlet>\n\t</div>\n\n\t\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/default.component.html
// module id = ../../../../../src/app/theme/pages/default/default.component.html
// module chunks = main